import React, { FC } from 'react';
import { View } from 'react-native';
import { isPhone } from '@helpers';
import { scale } from '@components/frame';
import { InlineErrorFallback } from '@v2/components/errorBoundary';
import type { ErrorFallbackProps } from '@v2/components/errorBoundary';
import { PERFORMANCE_CHART_BLOCK_WIDTH, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';

// Constrain the inline fallback to the same centered width as the performance chart blocks
const PerformanceScreenErrorFallback: FC<ErrorFallbackProps> = (props) => {
  const { IS_NARROW_WEB, fullWidth: width } = useDeviceSize();
  const blockWidth = isPhone && !IS_NARROW_WEB ? width - scale(SCREEN_PADDING_HORIZONTAL) * 2 : scale(PERFORMANCE_CHART_BLOCK_WIDTH);

  return (
    <View style={{ width: '100%', alignItems: 'center' }}>
      <View style={{ width: blockWidth }}>
        <InlineErrorFallback {...props} />
      </View>
    </View>
  );
};

export default PerformanceScreenErrorFallback;
